import { SyncRoute } from '@/system-modules/sync/v1/api/SyncRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { PushResult } from '@/contracts/system-modules/sync/dto/PushResult'
import { PushOperationsParams } from '@/system-modules/sync/v1/api/v1/sync/PushOperations/Dto/PushOperationsParams'

export class PushOperationsRoute extends SyncRoute<PushOperationsParams, PushResult> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/sync/operations'
  }

  /** Без сервера все операции считаются принятыми */
  offline(params: PushOperationsParams): Promise<ApiResponse<PushResult>> {
    return Promise.resolve(new ApiResponse({
      success: true,
      data: new PushResult({ accepted: params.operations.map((operation) => operation.time), rejected: [] }),
    }))
  }
}
